var Alberta = "亚伯达省";
var Manitoba = "马尼托巴省";
var Nunavut = "努纳乌特";
var Ontario = "安大略省";
var Quebec = "魁北克省";
var Saskatchewan = "萨斯喀彻温省";
var Yukon = "育空";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "不列颠哥伦比亚省",
	Manitoba: Manitoba,
	"New Brunswick": "新布伦兹维克省",
	"Newfoundland and Labrador": "纽芬兰和拉布拉多",
	"Northwest Territories": "西北地区",
	"Nova Scotia": "新斯科舍省",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "爱德华王子岛",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
